import type {
  AnimationProperties,
  AnimationsKit,
  EffectRangeAll,
} from '../../../types';

const name = 'SkewPanScroll';
const properties: AnimationProperties = {
  schema: {},
};

const ease = 'linear';
const powerMap = {
  soft: { skewX: 10 },
  medium: { skewX: 17 },
  hard: { skewX: 24 },
};

const directionMap = {
  right: -1,
  left: 1,
};

const rangeValues = {
  in: (skewX: number, startX: number, _endX: number) => ({
    fromValues: { skewX, startX },
    toValues: { skewX: 0, endX: 0 },
  }),
  out: (skewX: number, startX: number, _endX: number) => ({
    fromValues: { skewX: 0, startX: 0 },
    toValues: { skewX: -skewX, endX: startX },
  }),
  continuous: (skewX: number, startX: number, endX: number) => ({
    fromValues: { skewX, startX },
    toValues: { skewX: -skewX, endX },
  }),
};

/**
 * SkewPanScroll
 */
function animate(
  kit: AnimationsKit,
  elements: HTMLElement[],
  _duration: number,
  _delay: number,
  {
    skew = 10,
    direction = 'right',
    power,
    range = 'in',
    ...params
  }: {
    skew?: number;
    direction?: keyof typeof directionMap;
    power?: keyof typeof powerMap;
    range?: EffectRangeAll;
  } = {},
) {
  const sequence = kit.sequence(params);
  elements.forEach((element) => {
    const { left, width } = element.getBoundingClientRect();
    const { innerWidth } = kit.frame;
    const positions = {
      left: {
        startX: -left - width,
        endX: innerWidth - left,
      },
      right: {
        startX: innerWidth - left,
        endX: -left - width,
      },
    };

    const skewX =
      (typeof power === 'undefined' ? skew : powerMap[power].skewX) *
      directionMap[direction];
    const { startX, endX } = positions[direction];
    const { fromValues, toValues } = rangeValues[range](skewX, startX, endX);

    sequence.add([
      kit.animate('BaseSkew', element, 1000, 0, {
        from: { skewX: fromValues.skewX },
        to: { skewX: toValues.skewX },
        ease,
      }),
      kit.animate('BasePosition', element, 1000, 0, {
        from: { x: fromValues.startX },
        to: { x: toValues.endX },
        ease,
      }),
    ]);
  });
  return sequence.get();
}
export { name, properties, animate };
